module.exports = __webpack_public_path__ + "static/img/luatdaugia.d8e1eb7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/luatdaugia.jpg
// module id = ITvv
// module chunks = 1